import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "header-content" };
const _hoisted_2 = { class: "contents-sub-title-text" };
const _hoisted_3 = { class: "business-info" };
const _hoisted_4 = { class: "header-content" };
const _hoisted_5 = { class: "header-content" };
const _hoisted_6 = { class: "header-content" };
const _hoisted_7 = { class: "header-content" };
const _hoisted_8 = { class: "header-content" };
const _hoisted_9 = ["title"];
const _hoisted_10 = { class: "header-content" };
const _hoisted_11 = { class: "header-content" };
const _hoisted_12 = { class: "header-content" };
const _hoisted_13 = { class: "header-content" };
const _hoisted_14 = { class: "header-content" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_table = _resolveComponent("v-table");
    return (_openBlock(), _createBlock(_component_v_table, { class: "content-table ml-1" }, {
        default: _withCtx(() => [
            _createElementVNode("thead", _hoisted_1, [
                _createElementVNode("tr", null, [
                    _cache[0] || (_cache[0] = _createElementVNode("th", null, null, -1 /* CACHED */)),
                    _createElementVNode("th", _hoisted_2, _toDisplayString(_ctx.localeInfo.invoicee), 1 /* TEXT */)
                ])
            ]),
            _createElementVNode("tbody", _hoisted_3, [
                _createCommentVNode(" 등록번호(사업자번호) "),
                _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.localeInfo.businessNumber), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoiceeBusinessNumber), 1 /* TEXT */)
                ]),
                _createCommentVNode(" 종사업장 "),
                _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.localeInfo.subBusinessName), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoiceeSubBusinessName), 1 /* TEXT */)
                ]),
                _createCommentVNode(" 상호 "),
                _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.localeInfo.businessName), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoiceeBusinessName), 1 /* TEXT */)
                ]),
                _createCommentVNode(" 성명(대표자명) "),
                _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.localeInfo.ceoName), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoiceeCeoName), 1 /* TEXT */)
                ]),
                _createCommentVNode(" 사업장 주소 "),
                _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.localeInfo.businessAddress), 1 /* TEXT */),
                    _createElementVNode("td", {
                        class: "address",
                        title: _ctx.taxInvoiceData.formattedInvoiceeAddress
                    }, _toDisplayString(_ctx.taxInvoiceData.formattedInvoiceeAddress), 9 /* TEXT, PROPS */, _hoisted_9)
                ]),
                _createCommentVNode(" 업태 "),
                _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.localeInfo.businessCondition), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoiceeBusinessCondition), 1 /* TEXT */)
                ]),
                _createCommentVNode(" 종목 "),
                _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.localeInfo.businessType), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoiceeBusinessType), 1 /* TEXT */)
                ]),
                _createCommentVNode(" 담당자 "),
                _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.localeInfo.businessManager), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoiceeContectInfo.name), 1 /* TEXT */)
                ]),
                _createCommentVNode(" 연락처 "),
                _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.localeInfo.businessPhone), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoiceeContectInfo.telephone), 1 /* TEXT */)
                ]),
                _createCommentVNode(" 이메일 "),
                _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.localeInfo.businessEmail), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(_ctx.taxInvoiceData.formattedInvoiceeContectInfo.email), 1 /* TEXT */)
                ])
            ])
        ]),
        _: 1 /* STABLE */
    }));
}
